export default __webpack_public_path__ + "static/camiones-8ad37382525928dee1981e95a15771d1.png";